export const TIME_UNIT_OPTIONS = [
  { value: 'minutes', label: 'minutes' },
  { value: 'hours', label: 'hours' },
  { value: 'days', label: 'days' },
  { value: 'weeks', label: 'weeks' },
  { value: 'months', label: 'months' },
];

export const SELECT_STYLES = {
  control: (provided: any) => ({
    ...provided,
    minHeight: '32px',
    fontSize: '14px',
  }),
  menu: (provided: any) => ({
    ...provided,
    zIndex: 9999,
  }),
};

export const RELATIVE_TIME_UNIT_MAP: { [key: string]: string } = {
  m: 'minutes',
  h: 'hours',
  d: 'days',
  w: 'weeks',
  M: 'months',
};

export const RELATIVE_TIME_UNIT_MAP_SINGULAR: { [key: string]: string } = {
  m: 'minute',
  h: 'hour',
  d: 'day',
  w: 'week',
  M: 'month',
};

export const UNIT_TO_RELATIVE_MAP: { [key: string]: string } = {
  minutes: 'm',
  hours: 'h',
  days: 'd',
  weeks: 'w',
  months: 'M',
};
// Matches a simple time string like "15m" (digits followed by a unit character).
export const RELATIVE_TIME_REGEX = /^(\d+)([mhdwM])$/;
// Matches a full relative time value like "now-15m".
export const RELATIVE_VALUE_REGEX = /^now-(\d+)([mhdwM])$/;
